import { CircularProgress } from '@mui/material';
import { Suspense, lazy } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { buildAgentTabPath, EVA_WORKLIST_TAB } from '../../agents/routes';
import { RequireInsuranceVerifyAccess } from './RequireInsuranceVerifyAccess';

const VerificationDashboard = lazy(() => import('../features/dashboard/pages/VerificationDashboard'));
const VerificationWorklist = lazy(() => import('../features/worklist/pages/VerificationWorklist'));
const AssignmentManagement = lazy(() => import('../features/assignment/pages/AssignmentManagement'));
const VerificationDetail = lazy(() => import('../features/detail/pages/VerificationDetail'));
const CaseSearch = lazy(() => import('../features/search/pages/CaseSearch'));
const PreQuoteListPage = lazy(() => import('../features/preQuotes/pages/PreQuoteListPage'));
const PreQuoteDetailPage = lazy(() => import('../features/preQuotes/pages/PreQuoteDetailPage'));

export function VerificationDashboardRouteElement() {
  return (
    <Suspense fallback={<CircularProgress data-testid="financial-clearance-suspense-fallback" />}>
      <VerificationDashboard />
    </Suspense>
  );
}

export function VerificationWorklistRouteElement() {
  return (
    <Suspense fallback={<CircularProgress data-testid="financial-clearance-suspense-fallback" />}>
      <VerificationWorklist />
    </Suspense>
  );
}

export function AssignmentManagementRouteElement() {
  return (
    <Suspense fallback={<CircularProgress data-testid="financial-clearance-suspense-fallback" />}>
      <AssignmentManagement />
    </Suspense>
  );
}
export function VerificationDetailRouteElement() {
  return (
    <Suspense fallback={<CircularProgress data-testid="financial-clearance-suspense-fallback" />}>
      <VerificationDetail />
    </Suspense>
  );
}

export function CaseSearchRouteElement() {
  return (
    <Suspense fallback={<CircularProgress data-testid="financial-clearance-suspense-fallback" />}>
      <CaseSearch />
    </Suspense>
  );
}

export function PreQuoteListRouteElement() {
  return (
    <RequireInsuranceVerifyAccess>
      <Suspense fallback={<CircularProgress data-testid="financial-clearance-suspense-fallback" />}>
        <PreQuoteListPage />
      </Suspense>
    </RequireInsuranceVerifyAccess>
  );
}

export function PreQuoteDetailRouteElement() {
  return (
    <RequireInsuranceVerifyAccess>
      <Suspense fallback={<CircularProgress data-testid="financial-clearance-suspense-fallback" />}>
        <PreQuoteDetailPage />
      </Suspense>
    </RequireInsuranceVerifyAccess>
  );
}

/**
 * The Agent Dashboard was folded into the EVA agent worklist tab. This redirect preserves old
 * links (`/financial-clearance/agent-dashboard?company=...`) by forwarding to the EVA tab.
 */
export function LegacyAgentDashboardRedirect() {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const company = search.get('company');

  return <Navigate to={buildAgentTabPath('eva', EVA_WORKLIST_TAB, company ?? undefined)} replace />;
}
